export default __webpack_public_path__ + "static/media/addprofile.4e93cda6.svg";